import http from '@/utils/request';

// 退款申请列表
export const getApplyBopList = (data = {}) => {
  return http.post({
    url: '/receipt/refund/applyBopList',
    data,
  });
};

// 退款申请详情
export const getApplyDetail = (data = {}) => {
  return http.post({
    url: '/receipt/refund/applyDetail',
    data,
  });
};

// 退款申请审核
export const setRefundApproval = (data = {}) => {
  return http.post({
    url: '/receipt/refund/applyApproval',
    data,
  });
};

// 退款-退款申请列表导出
export const EXPORT_APPROVAL_REFUND = '/receipt/export/applyRefund';


// 退款单-列表
export const getRefundChannelList = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/bopList',
    data,
  });
};

// 退款单-详情
export const getRefundChannelDetail = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/detail',
    data,
  });
};

// 退款单-取消
export const getRefundChannelCancel = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/cancel',
    data,
  });
};

// 退款-退款单列表导出
export const EXPORT_REFUND = '/receipt/export/orderRefund';

// 退款单-获取支付方式
export const getRefundPayMethod = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/getPayMethod',
    data,
  });
};

// 退款单-线上退款
export const setPayOnlineSubmit = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/payOnlineSubmit',
    data,
  });
};

// 退款单-线上退款
export const setPayOfflineSubmit = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/payOfflineSubmit',
    data,
  });
};

// 退款单-发起付款-发送验证码
export const getRefundSendPayCode = (data = {}) => {
  return http.post({
    url: '/receipt/refund/channel/sendPayCode',
    data,
  });
};
